import { render, staticRenderFns } from "./otd-overview.vue?vue&type=template&id=0b437d11"
import script from "./otd-overview.vue?vue&type=script&lang=ts"
export * from "./otd-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports